import 'styled-components'

interface Fontsize {
  small: string
  normal: string
  medium: string
  large: string
  extraLarge?: string
}

export const mobile: Fontsize = {
  large: '32px',
  medium: '18px',
  small: '12px',
  normal: '16px',
}

export const desktop: Fontsize = {
  extraLarge: '3.0vw',
  large: 'clamp(18px,2.1vw,24px)',
  medium: 'clamp(16px,1.2vw,18px)',
  normal: 'clamp(16px,1.04vw,18px)',
  small: 'clamp(16px,0.9vw,18px)',
}
